import {AbstractProfileCollection} from 'collection/abstractProfileCollection';
import {Service} from '../model/service';

export const Services = AbstractProfileCollection.extend({
    _name: 'Services',
    model: Service,
    urlRoot: '/services/get.json',
});
